import { ProductWorkDto, defaultProductWorkDto } from 'src/dtos/productWork/ProductWorkDto';
import { defaultTqcInspectItemDto, TqcInspectItemDto } from 'src/dtos/tqcInspectItem/tqcInspectItemDto';
import { formatDate } from 'src/utils/string/stringUtil';

/** TQC2010 상단 그리드 DTO */
export interface TQC2010_R01HeaderDto extends ProductWorkDto {
	jobTeamNm: string;
	inspectType: string;
	inspectTypeNm: string;
	inspectorEmp?: string;
	inspectorEmpNm?: string;
	inspectDt?: string;
	inspectTime?: string;
}

export const defaultTQC2010_R01HeaderDto: TQC2010_R01HeaderDto = {
	...defaultProductWorkDto,
	jobTeamNm: '',
	inspectType: '',
	inspectTypeNm: '',
	inspectorEmp: '',
	inspectorEmpNm: '',
	inspectDt: undefined,
	inspectTime: '',
};

/** TQC2010 하단 Info 폼 상태 (UI 전용) */
export interface TQC2010_R01InfoDto {
	compCd: string;
	compNm: string;
	workProcess: string;
	itemCd: string;
	itemNm: string;
	workEmp: string;
	workEmpNm: string;
	inspectType: string;
	inspectTypeNm: string;
	inspectorEmp: string;
	inspectorEmpNm: string;
	inspectDt: string | undefined;
	inspectTime: string;
}

const getDefaultInspectTime = (): string => {
	const now = new Date();
	const hours = String(now.getHours()).padStart(2, '0');
	const minutes = String(now.getMinutes()).padStart(2, '0');
	return `${hours}:${minutes}`;
};

export const defaultTQC2010_R01InfoDto: TQC2010_R01InfoDto = {
	compCd: '',
	compNm: '',
	workProcess: '',
	itemCd: '',
	itemNm: '',
	workEmp: '',
	workEmpNm: '',
	inspectType: '',
	inspectTypeNm: '',
	inspectorEmp: '',
	inspectorEmpNm: '',
	inspectDt: formatDate(new Date()),
	inspectTime: getDefaultInspectTime(),
};

/** 공정지시 행 기준 Info 매핑 (검사구분은 SearchSection 값을 Content에서 덮어씀) */
export const createInfoFromRow = (row: TQC2010_R01HeaderDto): TQC2010_R01InfoDto => ({
	compCd: row.compCd ?? '',
	compNm: row.compNm ?? '',
	workProcess: row.workProcess ?? '',
	itemCd: row.itemCd ?? '',
	itemNm: row.itemNm ?? '',
	workEmp: row.workEmp ?? '',
	workEmpNm: row.workEmpNm ?? '',
	inspectType: '',
	inspectTypeNm: '',
	inspectorEmp: '',
	inspectorEmpNm: '',
	inspectDt: formatDate(new Date()),
	inspectTime: getDefaultInspectTime(),
});

export type GridRowData = TQC2010_R01HeaderDto;

/** TQC2010 하단 검사항목 그리드 DTO */
export interface TQC2010_R01DetailDto extends TqcInspectItemDto {
	specValue1: string;
	specRange: string;
	specValue2: string;
	inspUnit: string;
	valueType: string;
	inspClass: string;
	specRangeNm: string;
	valueTypeNm: string;
	inspClassNm: string;

	resultValue1: string;

	// 기존 검사결과가 있을 때만 채워짐 (없으면 빈 값)
	inspectType?: string;
	inspectorEmp?: string;
	inspectorEmpNm?: string;
	inspectDt?: string;
	inspectTime?: string;
}

export const defaultTQC2010_R01DetailDto: TQC2010_R01DetailDto = {
	...defaultTqcInspectItemDto,
	specValue1: '',
	specRange: '',
	specValue2: '',
	inspUnit: '',
	valueType: '',
	inspClass: '',
	specRangeNm: '',
	valueTypeNm: '',
	inspClassNm: '',
	resultValue1: '',
};

/** 검사결과 저장 요청 - 디테일 항목 */
export interface TQC2010_R01Dto {
	headerDto: TQC2010_R01HeaderDto;
	detailDtoList: TQC2010_R01DetailDto[];
}

/** 검사결과 저장 요청 - Info 헤더 + 디테일 리스트 */
